import { Box, Typography, useMediaQuery } from '@mui/material'
import { useState } from 'react'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { motion } from 'motion/react'
import { useDispatch } from 'react-redux'
import GenericBtn from '../../../../components/Buttons/OfoqThemeBtn'
import SideButtonContainer from '../../../../components/Cards/helpers/SideButtonContainerWithModal'
import UseTranslation from '../../../../hooks/UseTranslation'
import { ReactComponent as Checkmark } from '../../../../images/Checkmark.svg'
import { ReactComponent as XsCancel } from '../../../../images/close.svg'
import { ReactComponent as Cancel } from '../../../../images/cancelX.svg'
import SelectionModel from './SelectionModel'
import { retrieveNotificationInboxWithQueries } from '../../../../redux/features/notifications/notificationInbox/notificationInboxThunk'
import SideButtonContainerItem from '../../../../components/Cards/helpers/SideButtonContainerWithModal/SideButtonContainerItem'
import { arrowRotate } from '../../../../utils/animation'

const SelectRequest = ({
  selectionMode, setSelectionMode, customStyle,
  selectedCards, setSelectedCards,
}) => {
  const isXsScreen = useMediaQuery((theme) => theme.breakpoints.only('xs'))
  const { t } = UseTranslation()
  const [isSelectionModalOpen, setIsSelectionModalOpen] = useState({ status: false, type: 'approve' })
  const [isOpen, setIsOpen] = useState(false)
  const dispatch = useDispatch()

  const handleToggleSelection = () => {
    if (selectionMode) {
      setSelectedCards([])
    }
    setSelectionMode(!selectionMode)
  }
  const handleSelectionClick = (type) => {
    setIsSelectionModalOpen({
      status: true,
      type,
    })
  }

  const handleArrowRotate = () => {
    setIsOpen(!isOpen)
  }
  return (
    <Box sx={[styles.root, customStyle]}>
      {isXsScreen ? (
        <Box sx={styles.xsHeader}>
          {!selectionMode ? (
            <GenericBtn
              name={t?.['Select Requests']}
              startIcon={<Checkmark />}
              onClick={handleToggleSelection}
              customStyle={styles.xsSelectButton}
            />
          ) : (
            <Box sx={styles.xsSelectionHeader}>
              <Box sx={[styles.flexBetween, styles.selectContainer]}>
                <Typography sx={styles.selectTitle}>
                  <span style={styles.textColor}>
                    {selectedCards?.length}
                  </span>
                  {` / 10 ${t?.Selected}`}
                  <Box sx={styles.actionBtnContainer}>
                    <GenericBtn
                      name={t?.['Approve selected']}
                      onClick={() => handleSelectionClick('approve')}
                      disabled={selectedCards?.length === 0}
                      customStyle={{
                        ...styles.approveBtn,
                        ...(selectedCards?.length === 0 && styles.disabledBtn),
                      }}
                    />
                    <GenericBtn
                      startIcon={<XsCancel />}
                      onClick={handleToggleSelection}
                      customStyle={styles.xsCancelButton}
                    />
                    <GenericBtn
                      name={t?.['Reject selected']}
                      onClick={() => handleSelectionClick('reject')}
                      disabled={selectedCards?.length === 0}
                      customStyle={{
                        ...styles.rejectBtn,
                        ...(selectedCards?.length === 0 && styles.disabledBtn),
                      }}
                    />
                  </Box>
                </Typography>

              </Box>
            </Box>
          )}
        </Box>
      ) : (
        <Box sx={styles.header}>
          {!selectionMode ? (
            <GenericBtn
              name={t?.['Select Requests']}
              startIcon={<Checkmark />}
              onClick={handleToggleSelection}
              customStyle={styles.selectButton}
            />
          ) : (
            <Box sx={styles.selectionHeader}>
              <SideButtonContainer
                sx={styles.sideButtonContainer}
                customStyle={styles.selectedEmployee}
                customBtnIcon={(
                  <Box
                    sx={[styles.flexBetween, styles.selectContainer]}
                    onClick={handleArrowRotate}
                  >
                    <Typography sx={styles.selectTitle}>
                      <span style={styles.textColor}>
                        {selectedCards?.length}
                      </span>
                      {` / 10 ${t?.Selected}`}
                      <KeyboardArrowUpIcon
                        component={motion.svg}
                        variants={arrowRotate}
                        initial="initial"
                        animate={isOpen ? 'animate' : 'initial'}
                        transition="transition"
                        sx={styles.selectIcon}
                      />

                    </Typography>
                  </Box>
                )}
              >
                <SideButtonContainerItem
                  onClick={() => selectedCards?.length > 0 && handleSelectionClick('approve')}
                  customStyle={styles.actionText}
                >
                  {t?.['Approve selected']}
                </SideButtonContainerItem>

                <SideButtonContainerItem
                  onClick={() => selectedCards?.length > 0 && handleSelectionClick('reject')}
                  customStyle={styles.actionText}
                >
                  {t?.['Reject selected']}
                </SideButtonContainerItem>
              </SideButtonContainer>
              <GenericBtn
                name={t?.['Cancel Selection']}
                startIcon={<Cancel />}
                onClick={handleToggleSelection}
                customStyle={styles.cancelButton}
              />
            </Box>
          )}
        </Box>
      )}
      <SelectionModel
        modalStatus={isSelectionModalOpen}
        setModalStatus={setIsSelectionModalOpen}
        selectedData={selectedCards}
        setSelectedCards={setSelectedCards}
        actionAfterSuccess={
        () => dispatch(retrieveNotificationInboxWithQueries({ resetQueries: true }))
      }
      />
    </Box>
  )
}

const styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginLeft: '5px',
  },
  xsHeader: {
    display: 'flex',
    alignItems: 'center',
  },
  xsSelectButton: {
    color: 'primary.main',
    backgroundColor: 'transparent !important',
    paddingLeft: '0px !important',
    fontSize: '12px !important',
    '& svg': {
      width: '15px',
      height: '15px',
    },
    '&:hover': {
      color: 'primary.main',
      boxShadow: 'none !important',
    },
  },
  xsCancelButton: {
    backgroundColor: 'transparent !important',
    minWidth: '40px !important',
    height: '40px !important',
    border: (theme) => `1px solid ${theme.palette.grey[200]}`,
    borderRadius: '10px !important',
    padding: '6px 5px !important',
    margin: '0px !important',
    '&:hover': {
      boxShadow: 'none !important',
    },
    '& svg': {
      width: '16px',
      height: '16px',
    },
    '& span': {
      margin: '0px !important',
    },
  },
  xsSelectionHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    width: '100%',
    marginTop: { xs: '10px', sm: '0px' },
    '& span, p': {
      fontSize: '12px !important',
    },
  },
  sideButtonContainer: {
    height: '100%',
  },
  selectedEmployee: {
    width: 'max-content',
    border: 'unset !important',
    color: 'text.hint',
    padding: '0px 5px',
  },
  flexBetween: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  selectContainer: {
    gap: 1,
  },
  selectTitle: {
    height: '100%',
    fontSize: { xs: '13px', sm: '14px' },
    fontWeight: '700',
    color: 'grey.500',
    textAlign: 'center',
    textTransform: 'capitalize',
  },
  textColor: {
    color: '#29CC8B',
  },
  actionBtnContainer: {
    display: 'flex',
    position: 'fixed',
    bottom: 0,
    zIndex: 100,
    right: 0,
    left: 0,
    width: '95%',
    border: 'grey.200',
    backgroundColor: 'background.paper',
    padding: '10px 10px 15px 10px',
  },
  approveBtn: {
    color: 'primary.main',
    px: '5px !important',
    mx: '5px !important',
    textTransform: 'none',
    backgroundColor: 'background.lightGreen',
    width: '100%',
    boxShadow: 'none !important',
    maxWidth: '100% !important',
    '&:hover': {
      color: 'text.main',
      boxShadow: 'none !important',
    },
  },
  rejectBtn: {
    color: 'error.main',
    px: '5px !important',
    mx: '5px !important',
    textTransform: 'none',
    backgroundColor: 'background.lightRed',
    width: '100%',
    boxShadow: 'none !important',
    maxWidth: '100% !important',
    '&:hover': {
      backgroundColor: 'error.main',
      color: 'text.main',
      boxShadow: 'none !important',
    },
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  selectButton: {
    color: 'primary.main',
    backgroundColor: 'transparent !important',
    paddingLeft: '0px !important',
    '&:hover': {
      color: 'primary.main',
      boxShadow: 'none !important',
    },
  },
  cancelButton: {
    color: 'error.main',
    backgroundColor: 'transparent !important',
    maxWidth: '165px !important',
    '&:hover': {
      color: 'error.main',
      boxShadow: 'none !important',
    },
  },
  disabledBtn: {
    color: 'grey.500',
    backgroundColor: 'grey.200',
    cursor: 'not-allowed !important',
    pointerEvents: 'none !important',
  },
  selectionHeader: {
    display: { xs: 'none', sm: 'flex' },
    alignItems: 'center',
    gap: '40px',
    width: '100%',
  },
  selectIcon: {
    verticalAlign: 'middle',
    display: 'inline-flex',
    marginBottom: '3px',
  },
  actionText: {
    display: 'flex',
    width: '95%',
    alignItems: 'flex-end',
    textTransform: 'capitalize',
    cursor: 'pointer',
    margin: { xs: '10px 0px 20px', sm: '10px -5px 10px 5px' },
    padding: '0px 0px 5px !important',
    gap: '10px',
    fontSize: '14px',
  },
}
export default SelectRequest
